<template>
    <!-- <v-card> -->
        <v-radio-group
            :model-value="modelValue.value"
            @update:model-value="handleChange"
            :error-messages="modelValue.error"
            :name="modelValue.name"
            :id="modelValue.id"        
        >
            <template v-slot:label>
                <div>{{ modelValue.title }}</div>
            </template>
            <v-radio
                v-for="option in modelValue.options"
                :key="option.value"
                :label="option.title"
                :value="option.value"
            />
        </v-radio-group>
    <!-- </v-card> -->
</template>

<script>
export default {
    name: 'RadioGroupComponent',

    props: ['modelValue',], //modelValue - it the name of the prop that will be used for v-model binding (from parent component)
    emits: ['update:modelValue'],

    data() {
        return {
            
        };
    },

    methods: {
        handleChange(newValue) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                value: newValue,
                error: '', // Reset any previous error
            });
        }
    }

}
</script>

<style scoped>
</style>